export const STATSIG_EXPERIMENT = {
  IMMIGRATION_CMN: "immigration_cmn",
  funnel_test_questions_buttons_feedback:
    "funnel_test_questions_buttons_feedback",
  imm_funnel_fiance_visa_steps_and_feedback_2025_04_28:
    "imm_funnel_fiance_visa_steps_and_feedback_2025_04_28",
} as const;

export type StatsigExperimentName = keyof typeof STATSIG_EXPERIMENT;

export const featureFlagNames = {
  AA_TEST: "AA_TEST",
  AA_TEST_FAMILY_GENERAL: "AA_TEST_FAMILY_GENERAL",
  AA_TEST_FAMILY_SUB_PRACTICES: "AA_TEST_FAMILY_SUB_PRACTICES",
  FUNNEL_TEST_ATTORNEY_AVAILABILITY: "FUNNEL_TEST_ATTORNEY_AVAILABILITY",
  FUNNEL_TEST_DIRECT_LSS_DIVORCE_FLOW: "FUNNEL_TEST_DIRECT_LSS_DIVORCE_FLOW",
  FUNNEL_TEST_PRE_CLIENT_PORTAL: "FUNNEL_TEST_PRE_CLIENT_PORTAL",
  funnel_test_questions_buttons_feedback:
    STATSIG_EXPERIMENT.funnel_test_questions_buttons_feedback,
  LEGAL_PLAN_RELEASE: "LEGAL_PLAN_RELEASE",
} as const;

export type FeatureFlagName = keyof typeof featureFlagNames;
